import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { ChildAccountLetterOrderAuthorityValue, ChildAccountTimelineAuthorityValue, ChildAccountAuthorityValue, ChildAccountDownloadHistoryAuthorityValue } from '../../../constants/ComponentTypes';
import { validateChildAccount } from '../../../utils/validator';
import DialogModal from '../../common/DialogModal';
import Button from '../../Parts/Button';
import TextField from 'material-ui/TextField';
import { FormControl } from 'material-ui/Form';
import * as Messages from '../../../constants/Messages';
import MenuItem from 'material-ui/Menu/MenuItem';
import Select from 'material-ui/Select';
import { InputLabel } from 'material-ui/Input';
import Checkbox from 'material-ui/Checkbox';
import Typography from 'material-ui/Typography';
import { InputAdornment } from 'material-ui';
import NotificationBar from '../../Parts/NotificationBar.jsx';
import { isEnabledSendLetter, isEnabledExportExecutiveList, hasEverBeenEnabledExportPlan } from '../../../utils/planUtils';

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '960px',
    minWidth: '1000px',
  },

  contentContainer: {
    margin: '0px',
    padding: '20px 25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'left',
    position: 'relative',
    boxSizing: 'border-box',
  },

  detailContentContainer: {
    margin: '0px',
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'left',
    position: 'relative',
    boxSizing: 'border-box',
  },

  content: {
    padding: '20px 25px',
    width: '100%',
    boxSizing: 'border-box',
  },

  form: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    padding: '20px',
    width: '100%',
    boxSizing: 'border-box',
  },

  sectionTitle: {
    fontSize: '13px',
    background: '#F4F6F9',
    padding: '10px',
    width: '100%',
    boxSizing: 'border-box',
  },

  row: {
    marginTop: '20px',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
    justifyContent: 'center',
  },

  text: {
    paddingLeft: "5px",
    fontSize: "14px",
  },

  input: {
    boxSizing: 'border-box',
  },

  left: {
    width: 'calc(50% - 10px)',
    marginRight: '20px',
  },

  right: {
    width: 'calc(50% - 10px)',
  },

  authorityItem: {
    marginTop: '20px',
  },

  fullWidth: {
    width: '100%',
  },

  entry: {
    width: '100%',
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  checkboxContainer: {
    marginTop: '8px',
    padding: '12px 20px 20px',
    boxSizing: 'border-box',
    border: '1px solid #D8DBDF',
  },

  checkmark: {
    paddingLeft: '24px',
    position: 'relative',

    '&:before': {
      content: '""',
      position: 'absolute',
      width: '17px',
      height: '17px',
      borderRadius: '8.5px',
      background: '#1A65FF',
      right: '20px',
      top: '10px',
    },

    '&:after': {
      content: '""',
      position: 'absolute',
      borderLeft: '1px solid #FFFFFF',
      borderBottom: '1px solid #FFFFFF',
      width: '8px',
      height: '4px',
      transform: 'rotate(-45deg)',
      right: '24px',
      top: '14px',
    },
  },

  disabledButton: {
    backgroundColor: '#D8DBDF',
    color: '#D8DBDF',
    borderRadius: 'unset',
  },
});

class CreateChildAccountDialog extends React.Component {
  state = {
    showNotification: false,
    message: "",
    messageType: "success",
    errorMessage: '',
    showMessage: true,
    error: {},
    letter_order_authority: 1, //注文履歴権限のセレクトボックスの値
    timeline_authority: 1, //タイムラインのセレクトボックスの値
    executive_list_authority: 0, // キーマンデータベースのセレクトボックスの値
    house_list_authority: 0, //自社リストのセレクトボックスの値
    download_history_authority: 0, //ダウンロード履歴のセレクトボックスの値
    executive_list_order_letter: false,
    executive_list_edit_tag: false,
    executive_list_download_list: false, //リストダウンロードプラン(Pro)
    executive_list_download_letter_ordered_list: false, //Proプラン(new(2022/09版))
    house_list_order_letter: false,
    house_list_edit: false, //アドレスの追加/編集
    house_list_edit_tag: false,
    house_list_download_list: false,
    item: {
      name: '',
      kana: '',
      email: '',
      password: '',
      confirm_password: '',
    },
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.error !== nextProps.error && nextProps.error !== null) {
      if (
        typeof nextProps.error === "object" &&
        Object.keys(nextProps.error).length > 0
      ) {
        this.setState({
          error: {
            ...this.state.error,
            ...nextProps.error,
          },
        });
      } else if (typeof nextProps.error === "string") {
        this.displayNotification(nextProps.error, "error");
      }
    } else if (this.props.isSaving && !nextProps.isSaving && nextProps.error === null) {
      nextProps.toggleDialog();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.message === "" &&
      this.props.message &&
      this.props.message !== ""
    ) {
      this.displayNotification(this.props.message, "success");
    } else if (
      prevProps.errorMessage === "" &&
      this.props.errorMessage &&
      this.props.errorMessage !== ""
    ) {
      this.displayNotification(this.props.errorMessage, "error");
    } else if (
      prevProps.shortMessage === "" &&
      this.props.shortMessage &&
      this.props.shortMessage !== ""
    ) {
      this.displayNotification(this.props.shortMessage, "green");
    }
  }

  displayNotification = (message, type = "success") => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  handleCheck = (property) => e => {
    if (e.target.disabled) {
      return;
    }
    this.setState({
      [property]: !this.state[property],
    })
  }

  handleChange = property => e => {
    let item = this.state.item;
    let value = e.target.value;

    if (item.hasOwnProperty(property)) {
      item[property] = value;

      this.setState({
        item: item,
      })
    } else {
      this.setState({
        [property]: value,
      })
    }
  }

  validateItem = (property) => (event) => {
    let value = event.target.value;
    let err = {};

    if (property === "confirm_password") {
      err = validateChildAccount({
        password: this.state.item.password,
        [property]: value,
      });
    } else {
      err = validateChildAccount({
        [property]: value,
      });
    }

    let error = this.state.error;
    if (err.hasOwnProperty(property)) {
      error[property] = err[property];
    } else {
      delete error[property];
    }
    this.setState({
      error: error,
    });
  };

  validateForm = () => {
    let { error, item } = this.state;
    error = validateChildAccount(item);

    this.setState({
      error: error,
    });
    return error;
  };

  handleSubmit = () => {
    let { error, item, letter_order_authority, timeline_authority, executive_list_authority, house_list_authority, download_history_authority, executive_list_order_letter, executive_list_edit_tag, executive_list_download_list, executive_list_download_letter_ordered_list,
      house_list_order_letter, house_list_edit, house_list_edit_tag, house_list_download_list } = this.state;
    error = this.validateForm();

    if (Object.keys(error).length === 0) {
      this.props.postChildUser({
        parent_id: this.props.user.id,
        name: item.name,
        kana: item.kana,
        email: item.email,
        password: item.password,
        letter_order_authority: letter_order_authority,
        timeline_authority: timeline_authority,
        executive_list_authority: executive_list_authority,
        house_list_authority: house_list_authority,
        download_history_authority: download_history_authority,
        executive_list_order_letter: executive_list_order_letter,
        executive_list_edit_tag: executive_list_edit_tag,
        executive_list_download_list: executive_list_download_list,
        executive_list_download_letter_ordered_list: executive_list_download_letter_ordered_list,
        house_list_order_letter: house_list_order_letter,
        house_list_edit: house_list_edit,
        house_list_edit_tag: house_list_edit_tag,
        house_list_download_list: house_list_download_list
      })
    }
  }

  handleClose = () => {
    if (window.confirm(Messages.ADDRESS_UNSAVED)) {
      this.props.toggleDialog();
    }
  }

  countErrors = () => {
    return Object.keys(this.state.error).length;
  }

  renderNotification = () => {
    if (this.state.showNotification) {
      return (
        <div style={{ position: "fixed", zIndex: 1000, top: 10, width: "99%" }}>
          <NotificationBar
            message={this.state.message}
            type={this.state.messageType}
            open={this.state.showNotification}
            onHandleClose={() => {
              this.setState({
                showNotification: false,
              });
            }}
            autoClose={true}
            style={{
              width:
                this.state.messageType === "green" ? "fit-content" : "100%",
            }}
          ></NotificationBar>
        </div>
      );
    }
  };

  renderErrorMessage = () => {
    let message, style;
    if ((this.countErrors() > 0)) {
      if (this.state.error["message"]) {
        message = this.state.error["message"];
      } else {
        message = "エラー項目を確認してください。";
      }
      style = "error";
    } else if (this.state.errorMessage !== '') {
      message = this.state.errorMessage;
      style = "error";
    }

    if (message) {
      return (
        <NotificationBar
          message={message}
          type={style}
          open={true}
          autoClose={false}
          disableOnclickListener={true}
          style={{ transform: 'none', boxShadow: 'none', width: '100%', boxSizing: 'border-box', marginBottom: '20px' }}
        >
        </NotificationBar>
      )
    }
  }

  renderCheckboxContent = (info, i, property) => {
    const { classes } = this.props;
    return (
      <div className={classes.entry} onClick={this.handleCheck(info.key)} key={i}>
        <Checkbox
          color="primary"
          checked={this.state[property] === ChildAccountAuthorityValue.EDIT.value ? this.state[info.key] : false}
          onChange={this.handleCheck(info.key)}
          classes={{ disabled: classes.disabledButton }}
          style={{
            width: "17px",
            height: "17px",
          }}
          disabled={this.state[property] !== ChildAccountAuthorityValue.EDIT.value}
        />
        <Typography
          variant="subheading"
          className={classes.text}
          style={{ cursor: this.state[property] !== ChildAccountAuthorityValue.EDIT.value ? "" : "pointer", color: this.state[property] !== ChildAccountAuthorityValue.EDIT.value ? "#D8DBDF" : "#181819" }}
        >
          {info.title}
        </Typography>
      </div>
    )
  }

  render() {
    const { classes, isOpen, title, user, isSaving } = this.props;
    const { error } = this.state;
    const houseListCheckboxInfo = [
      { title: 'レター送付', key: 'house_list_order_letter' },
      { title: 'アドレスの追加 / 編集', key: 'house_list_edit' },
      { title: 'リストの追加 / 編集', key: 'house_list_edit_tag' },
      { title: 'キーマンリストDL', key: 'house_list_download_list' },
    ]

    let executiveListCheckboxInfo = [
      { title: 'リストの追加 / 編集', key: 'edit_tag' },
    ];

    if (isEnabledExportExecutiveList(user)) {
      executiveListCheckboxInfo.push(
        { title: 'キーマンリストDL', key: 'download_list' }
      );
    }

    if (isEnabledSendLetter(user)) {
      executiveListCheckboxInfo.push(
        { title: 'レター送付', key: 'order_letter' },
        { title: '注文済みキーマンDL', key: 'download_letter_ordered_list' }
      );
    }

    return (
      <DialogModal
        title={title}
        open={isOpen}
        onClose={this.handleClose}
        maxWidth={false}
        classes={{
          contentContainer: classes.detailContentContainer,
          paper: classes.paper,
        }}
      >
        <div className={classes.content}>
          {this.renderErrorMessage()}
          <div className={classes.form}>
            <div className={classes.formInner} style={{ pointerEvents: 'auto' }}>
              <div className={classes.row} style={{ marginTop: 0 }}>
                <div className={classes.sectionTitle}>基本情報</div>
              </div>

              <div className={classes.row}>
                <div className={classes.left}>
                  <TextField
                    id="name"
                    label="名前"
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        input: classes.Input
                      }
                    }}
                    InputLabelProps={{ shrink: true, }}
                    placeholder="名前を入力"
                    onBlur={this.validateItem("name")}
                    onKeyDown={this.handleKeyDown}
                    onChange={this.handleChange("name")}
                    error={error.hasOwnProperty("name")}
                    helperText={error.name}
                    className={classes.input}
                    fullWidth
                  />
                </div>
                <div className={classes.right}>
                  <TextField
                    id="kana"
                    label="名前（カナ）"
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{ shrink: true, }}
                    placeholder="フリガナを入力"
                    onBlur={this.validateItem("kana")}
                    onKeyDown={this.handleKeyDown}
                    onChange={this.handleChange("kana")}
                    error={error.hasOwnProperty("kana")}
                    className={classes.input}
                    helperText={error.kana}
                    fullWidth
                  />
                </div>
              </div>

              <div className={classes.row}>
                <div className={classes.fullWidth}>
                  <TextField
                    id="email"
                    label="メールアドレス"
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{ shrink: true, }}
                    placeholder="メールアドレスを入力"
                    onChange={this.handleChange("email")}
                    onBlur={this.validateItem("email")}
                    onKeyDown={this.handleKeyDown}
                    error={error.hasOwnProperty("email")}
                    helperText={error.email}
                    className={classes.input}
                    fullWidth
                  />
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.left}>
                  <TextField
                    id="password"
                    label="パスワード"
                    type="password"
                    InputProps={{
                      disableUnderline: true,
                      endAdornment:
                        <InputAdornment position="end">
                          <span className={classes.checkmark} style={{ display: this.state.item.password === '' || error.hasOwnProperty("password") ? 'none' : 'contents' }}></span>
                        </InputAdornment>
                    }}
                    InputLabelProps={{ shrink: true, }}
                    placeholder="英数字8文字以上"
                    onChange={this.handleChange("password")}
                    onBlur={this.validateItem("password")}
                    onKeyDown={this.handleKeyDown}
                    error={error.hasOwnProperty("password")}
                    className={classes.input}
                    helperText={error.password}
                    fullWidth
                  />
                </div>
                <div className={classes.right}>
                  <TextField
                    id="confirm_password"
                    label="パスワードを入力（確認用）"
                    type="password"
                    InputProps={{
                      disableUnderline: true,
                      endAdornment:
                        <InputAdornment position="end">
                          <span className={classes.checkmark} style={{ display: this.state.item.confirm_password === '' || error.hasOwnProperty("confirm_password") ? 'none' : 'contents' }}></span>
                        </InputAdornment>
                    }}
                    InputLabelProps={{ shrink: true, }}
                    placeholder="英数字8文字以上"
                    onChange={this.handleChange("confirm_password")}
                    onBlur={this.validateItem("confirm_password")}
                    onKeyDown={this.handleKeyDown}
                    error={error.hasOwnProperty("confirm_password")}
                    helperText={error.confirm_password}
                    className={classes.input}
                    fullWidth
                  />
                </div>
              </div>

              <div className={classes.row}>
                <div className={classes.sectionTitle}>権限設定</div>
              </div>

              {/* 権限は2列で、左列に1・3・5番目、右列に2・4番目を縦に積む。
                  キーマンデータベースなどチェックボックスで縦に長い項目があっても、左右の列の間に大きな空きができないようにする */}
              <div className={classes.row}>
                <div className={classes.left}>
                  <FormControl
                    fullWidth
                  >
                    <InputLabel shrink>注文履歴</InputLabel>
                    <Select
                      value={this.state.letter_order_authority}
                      onChange={this.handleChange("letter_order_authority")}
                      classes={{ select: classes.input }}
                      disableUnderline={true}
                      notched={+true}
                    >
                      {Object.values(ChildAccountLetterOrderAuthorityValue).map(item => (
                        <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <div className={classes.authorityItem}>
                    <FormControl
                      fullWidth
                    >
                      <InputLabel shrink>タイムライン</InputLabel>
                      <Select
                        value={this.state.timeline_authority}
                        onChange={this.handleChange("timeline_authority")}
                        classes={{ select: classes.input }}
                        disableUnderline={true}
                        notched={+true}
                      >
                        {Object.values(ChildAccountTimelineAuthorityValue).map(item => (
                          <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  <div className={classes.authorityItem}>
                    <FormControl
                      fullWidth
                    >
                      <InputLabel shrink>自社リスト</InputLabel>
                      <Select
                        value={this.state.house_list_authority}
                        onChange={this.handleChange("house_list_authority")}
                        classes={{ select: classes.input }}
                        disableUnderline={true}
                        notched={+true}
                      >
                        {Object.values(ChildAccountAuthorityValue).map(item => (
                          <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <div className={classes.checkboxContainer}>
                      {houseListCheckboxInfo.map((info, i) => this.renderCheckboxContent(info, i,'house_list_authority'))}
                    </div>
                  </div>
                </div>
                <div className={classes.right}>
                  {hasEverBeenEnabledExportPlan(user) && (
                    <FormControl
                      fullWidth
                    >
                      <InputLabel shrink>ダウンロード履歴</InputLabel>
                      <Select
                        value={this.state.download_history_authority}
                        onChange={this.handleChange("download_history_authority")}
                        classes={{ select: classes.input }}
                        disableUnderline={true}
                        notched={+true}
                      >
                        {Object.values(ChildAccountDownloadHistoryAuthorityValue).map(item => (
                          <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  {/* ダウンロード履歴を出さない場合は、右列の先頭になるため上の余白を付けない */}
                  <div className={hasEverBeenEnabledExportPlan(user) ? classes.authorityItem : undefined}>
                    <FormControl
                      fullWidth
                    >
                      <InputLabel shrink>キーマンデータベース</InputLabel>
                      <Select
                        value={this.state.executive_list_authority}
                        onChange={this.handleChange("executive_list_authority")}
                        classes={{ select: classes.input }}
                        disableUnderline={true}
                        notched={+true}
                      >
                        {Object.values(ChildAccountAuthorityValue).map(item => (
                          <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <div className={classes.checkboxContainer}>
                      {executiveListCheckboxInfo.map((info, i) => this.renderCheckboxContent(info, i, 'executive_list_authority'))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
            </div>
            <div className={classes.row}>
              <Button
                text="新規アカウント作成"
                handleClickButton={this.handleSubmit}
                loading={isSaving}
                disabled={this.countErrors() > 0}
                style={{ margin: '20px 0px', width: '185px' }}
              />
            </div>
          </div>
        </div>
      </DialogModal>
    );
  }
}

CreateChildAccountDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  postChildUser: PropTypes.func.isRequired,
  user: PropTypes.object,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  title: PropTypes.string,
};

export default withStyles(styles)(CreateChildAccountDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/dialogs/CreateChildAccountDialog.jsx